import React from 'react'
import { Document } from '@contentful/rich-text-types'
import { renderRichTextSingleLineContent } from '../../../renderer/rich-text'

interface SubmitButtonContentProps {
  isLoading: boolean
  loadingButtonText?: Document
  submitButtonText: Document
}

export const SubmitButtonContent: React.FC<SubmitButtonContentProps> = ({
  isLoading,
  loadingButtonText,
  submitButtonText,
}) => {
  return (
    <>
      {isLoading
        ? loadingButtonText
          ? renderRichTextSingleLineContent(loadingButtonText)
          : 'Generating'
        : renderRichTextSingleLineContent(submitButtonText)}
    </>
  )
}
